<template>
	<div class="md-layout">
		<div class="md-layout-item md-medium-size-50 md-size-50">
			<h4>{{translate(locale.allActivity)}}</h4>
		</div>
		<div class="md-layout-item md-medium-size-50 md-size-50 text-right">
			<md-button class="md-raised md-primary" @click="$router.push('/my_activities/new')">{{translate(locale.newActivity)}}</md-button>
		</div>
		<div class="md-layout-item md-medium-size-100 md-size-100">
			<md-card>
				<md-card-content>
					<loading v-if="!loaded" />
					<!-- <el-tabs v-model="tabName" v-if="loaded">
						<el-tab-pane label="My All Activities" name="first"></el-tab-pane>
						<el-tab-pane label="Create New Activity" name="second"></el-tab-pane>
					</el-tabs> -->
					<div v-if="loaded">
						<div class="md-layout">
							<div class="md-layout-item md-small-size-100 md-size-50">
								<md-field>
									<label>{{translate(locale.searchActivity)}}</label>
									<md-input v-model="search.text" type="text" @keyup.enter="searchHandler()"></md-input>
								</md-field>
							</div>
							<div class="md-layout-item md-small-size-70 md-size-25">
								<md-field>
									<label>{{translate(locale.status)}}</label>
									<md-select :placeholder="translate(locale.statusAll)" v-model="search.status">
										<md-option value="">{{translate(locale.all)}}</md-option>
										<md-option value="1">{{translate(locale.active)}}</md-option>
										<md-option value="0">{{translate(locale.disabled)}}</md-option>
									</md-select>
								</md-field>
							</div>
							<div class="md-layout-item md-small-size-30 md-size-25">
								<md-button class="md-raised md-primary" @click="searchHandler()" style="width: 100%">{{translate(locale.search)}}</md-button>
							</div>
						</div>
						<md-table v-if="activityList.length > 0">
							<md-table-row>
								<md-table-head></md-table-head>
								<md-table-head>{{translate(locale.thumbnail)}}</md-table-head>
								<md-table-head style="width: 50%">{{translate(locale.title)}}</md-table-head>
								<md-table-head style="min-width: 200px;">{{translate(locale.lastUpdate)}}</md-table-head>
								<md-table-head>{{translate(locale.status)}}</md-table-head>
								<md-table-head>{{translate(locale.action)}}</md-table-head>
							</md-table-row>

							<md-table-row v-for="(activity, index) in activityList">
								<!-- <md-table-cell></md-table-cell> -->
								<md-table-cell>​{{ index + 1 }}</md-table-cell>
								<md-table-cell><img :src="config.cdn + 'images/' + activity.image_cover_url" style="width: 100px"></md-table-cell>
								<md-table-cell><b>{{activity.name}}</b></md-table-cell>
								<md-table-cell><b>{{ activity.first_name }} {{ activity.last_name }}</b><br>{{ translate(config.datelify(activity.updated_date)) }}</md-table-cell>
								<md-table-cell>
									<span class="late" v-if="activity.status == 0">{{translate(locale.disabled)}}</span>
									<span class="green" v-if="activity.status == 1">{{translate(locale.active)}}</span>
								</md-table-cell>
								<md-table-cell>
									<md-button class="md-just-icon md-simple md-primary" v-if="activity.status == 1">
										<md-icon>visibility</md-icon>
										<md-tooltip md-direction="top">{{translate(locale.viewThis)}}</md-tooltip>
									</md-button>
									<md-button class="md-just-icon md-simple md-primary" v-if="activity.status == 0" @click="onEnable(activity.hash)">
										<md-icon>check_circle</md-icon>
										<md-tooltip md-direction="top">{{translate(locale.enableThis)}}</md-tooltip>
									</md-button>
									<router-link :to="'my_activities/edit/' + activity.hash">
										<md-button class="md-just-icon md-simple md-info">
											<md-icon>edit</md-icon>
											<md-tooltip md-direction="top">{{translate(locale.editThis)}}</md-tooltip>
										</md-button>
									</router-link>

									<md-button class="md-just-icon md-simple md-warn" v-if="activity.status == 1" @click="onDisable(activity.hash)">
										<md-icon>hide_source</md-icon>
										<md-tooltip md-direction="top">{{translate(locale.disableThis)}}</md-tooltip>
									</md-button>
									
									<md-button class="md-just-icon md-simple md-danger" v-if="activity.status == 0" @click="onDelete(activity.hash)">
										<md-icon>delete</md-icon>
										<md-tooltip md-direction="top">{{translate(locale.deleteThis)}}</md-tooltip>
									</md-button>
								</md-table-cell>
							</md-table-row>
						</md-table>
						<h5 class="text-center" v-if="activityList.length == 0 && loaded == true">{{translate(locale.noActivity)}}</h5>
						<div class="places-buttons text-center" v-if="loadMore">
							<md-button class="md-primary" @click="searchHandler(true)">{{translate(locale.showMore)}}</md-button>
						</div>
					</div>

					<md-dialog-confirm :md-active.sync="deleteDialogActive" md-title="Are you sure want to delete this activity ?" :md-confirm-text="translate(locale.delete)"
						:md-cancel-text="translate(locale.cancel)" @md-cancel="onCancel" @md-confirm="onDelete" />
						<md-dialog-confirm :md-active.sync="disableDialogActive" md-title="Are you sure want to disable this activity ?" :md-confirm-text="translate(locale.disable)"
						:md-cancel-text="translate(locale.cancel)" @md-cancel="onCancel" @md-confirm="onDisable" />
				</md-card-content>
			</md-card>
		</div>
	</div>
		
	</div>

</template>

<script>

	import { Datetime } from 'vue-datetime';
	export default {
		components: { Datetime },
		created() {
			this.searchHandler();
		},

		data() {
			return {
				tabName: "first",
				loaded: false,
				deleteDialogActive: false, deleteSelected: '',
				disableDialogActive: false, disableSelected: '',
				search: { text: "", status: "", type: "" },
				loadMore: false,
				activityList: []
			}
		},
		methods: {
			searchHandler(more = false) {
				this.$http.post(this.config.api + "/profile/activity/search", {
					text: this.search.text,
					status: this.search.status,
					offset: more ? this.activityList.length : 0
				}).then(data => {
					this.loaded = true;
					if (data.body.data.length == 50) this.loadMore = true;
					else this.loadMore = false;
					this.activityList = more ? this.activityList.concat(data.body.data) : data.body.data;
				})

			},

			showDeleteAction(id) {
				this.deleteSelected = id
				this.deleteDialogActive = true
			},
			onDelete(hash) {
				if(this.deleteSelected == "") {
					this.deleteDialogActive = true;
					this.deleteSelected = hash;
					return;
				}
				this.$http.post(this.config.api + "/profile/activity/delete", {
					hash: this.deleteSelected
				}).then(res => {
					if (res.body.status == 'success') {
						this.$notification.notify({
							message: "You have deleted the activity successfully.",
							icon: 'done',
							type: 'success'
						})
						this.searchHandler();
						this.onCancel();
					}
				})
			},
			onDisable(hash) {

				if(this.disableSelected == "") {
					this.disableDialogActive = true;
					this.disableSelected = hash;
					return;
				}
				this.$http.post(this.config.api + "/profile/activity/disable", {
					hash: this.disableSelected
				}).then(res => {
					if (res.body.status == 'success') {
						this.$notification.notify({
							message: "You have disabled the activity successfully.",
							icon: 'done',
							type: 'success'
						})
						this.searchHandler();
						this.onCancel();
					}
				})
			},

			onEnable(hash) {

				this.$http.post(this.config.api + "/profile/activity/enable", {
					hash: hash
				}).then(res => {
					if (res.body.status == 'success') {
						this.$notification.notify({
							message: "You have enabled the activity successfully.",
							icon: 'done',
							type: 'success'
						})
						this.searchHandler();
						this.onCancel();
					}
				})
			},
			onCancel() {
				this.deleteSelected = ""
				this.disableSelected = ""
				this.deleteDialogActive = false
				this.disableDialogActive = false
			},	
		}
	}
</script>
<style scoped>
	.product-thumbnail {
		width: 64px;
		height: 64px;
	}

	.grid-8 {
		text-align: center;
		max-width: 20%;
		min-width: 20%;
		flex: 0 0 20%;
	}

	.thumb-product {
		width: 50%;
	}
</style>



// WEBPACK FOOTER //
// src/pages/MyActivities/View.vue